import React, { useEffect, useState } from "react";
import "./ToolSuiteSection.css";
import AOS from "aos";
import "aos/dist/aos.css";

function ToolSuiteSection() {
  useEffect(() => {
    AOS.init({ duration: 800 });
  }, []);
  return (
    <>
      <div className="tools-suite-extra-row">
        {/* <img
          src={process.env.PUBLIC_URL + "/images/GenAI/top-left-icon.png"}
          alt="icon"
          className="top-left-icon"
        />
        <img
          src={process.env.PUBLIC_URL + "/images/GenAI/bottom-right-icon.png"}
          alt="icon"
          className="bottom-right-icon"
        /> */}
        <div className="tools-suite-row row1" data-aos="zoom-in-up">
          <div className="tools-suite-box">
            <h3>CodeMaster Pro</h3>
            <p>
              Gen AI software provides automated, detailed feedback to improve
              coding skills.
            </p>
            <p className="more-link">
              <a href="https://atci.lkm.accenture.com/LKMGenAITools/CodeMasterPro">
                More Insights
              </a>
            </p>
            <img
              src={
                process.env.PUBLIC_URL + "/images/GenAI/CodeMaster-img-new.png"
              }
              alt="tools"
              className="tools-suite-img"
            />
          </div>
          <div className="tools-suite-box">
            <h3>Progress Pro</h3>
            <p>
              Gen AI-powered tool increases skill retention with quizzes,
              challenges, tracking.
            </p>
            <p className="more-link">
              <a href="https://atci.lkm.accenture.com/LKMGenAITools/ProgressPro">
                More Insights
              </a>
            </p>
            <img
              src={
                process.env.PUBLIC_URL + "/images/GenAI/ProgressPro-img-new.png"
              }
              alt="tools"
              className="tools-suite-img"
            />
          </div>
        </div>
        <div className="tools-suite-row row2" data-aos="zoom-in-up">
          <div className="tools-suite-second-extra-row">
            <div className="tools-suite-box">
              <h3>CommsBuilder</h3>
              <p>
                CommsBuilder automates personalized internal communications,
                ensuring brand consistency and streamlining messaging.
              </p>
              <p className="more-link">
                <a href="https://atci.lkm.accenture.com/LKMGenAITools/CommsBuilder">
                  More Insights
                </a>
              </p>
              <img
                src={
                  process.env.PUBLIC_URL + "/images/GenAI/CommsBuilder-img.png"
                }
                alt="tools"
                className="tools-suite-img"
              />
            </div>
            <div className="tools-suite-box">
              <h3>Genius Tutor</h3>
              <p>
                AI educational platform with custom quizzes, content, coding for
                improved learning.
              </p>
              <p className="more-link">
                <a href="https://atci.lkm.accenture.com/LKMGenAITools/GeniusTutor">
                  More Insights
                </a>
              </p>
              <img
                src={
                  process.env.PUBLIC_URL + "/images/GenAI/GeniusTutor-img.png"
                }
                alt="tools"
                className="tools-suite-img"
              />
            </div>
          </div>
          <div className="tools-suite-box">
            <div className="tools-suite-content-box">
              <h3>SAMVAAD</h3>
              <p className="last-para">
                Leverage AI coach for business pitches and personalized
                real-time coaching.
              </p>
              <p className="more-link">
                <a href="https://atci.lkm.accenture.com/LKMGenAITools/Samvaad">
                  More Insights
                </a>
              </p>
            </div>
            <div className="tools-suite-content-box">
              <img
                src={
                  process.env.PUBLIC_URL + "/images/GenAI/samvaad-img-new.png"
                }
                alt="tools"
                className="tools-suite-img"
              />
            </div>
          </div>
        </div>
        <div className="tools-suite-row row3" data-aos="zoom-in-up">
          <div className="tools-suite-box">
            <h3>Measure My Learning</h3>
            <p>
              This tool assesses learning programs efficacy, engagement, skills
              acquired, business impact.
            </p>
            <p className="more-link">
              <a href="https://atci.lkm.accenture.com/LKMGenAITools/MeasureMyLearning">
                More Insights
              </a>
            </p>
            <img
              src={process.env.PUBLIC_URL + "/images/GenAI/MML-img.png"}
              alt="tools"
              className="tools-suite-img"
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default ToolSuiteSection;
